export class ChangePasswordDto {
  oldPassword = '';
  password = '';
  passwordConfirmation = '';
}